import React, { useEffect, useState, useCallback, useRef, useLayoutEffect } from 'react';
import PostItem from './post-item';
import { POST_STATUS, ROLES } from '../../utils/constants';
import useDidMountEffect from '../../utils/useDidMountEffect';
import queryString from 'query-string';
import { connect } from 'react-redux';
// import { Instagram } from 'react-content-loader';
import { useDispatch } from 'react-redux';
import { fetchPosts, appendPosts, resetPosts, setPostWasReset, setPostIsInitialized } from '../../../redux/actions';
import { isMobile } from 'react-device-detect';
import PostCategoryList from '../PostCategoryList';
// import { Modal } from 'react-bootstrap';
// import PrivaLogo from '../../images/logos/logo-12.png';
// import CCForm from '../CCForm';
import { useHistory } from 'react-router';
// import { Dialog, DialogContent } from '@mui/material';
// import CreditCardForm from '../../common/CreditCardForm';
import PostSkeleton from './Skeleton';
import { setPostThankyou } from '../../../redux/actions/post';
import PThankYou from '../PThankYou';

let perPage = 2;
if (!isMobile) {
    perPage = 10;
}

// uuser here is from server not from local storage
const PostsContent = ({
    refetch = false,
    setRefetch = () => ({}),
    isPu = false,
    user,
    status = POST_STATUS.PUBLISHED,
    // activePost,
    setPosts,
    posts,
    hasMore,
    isLoading,
    isInitialized,
    isReset,
    keyword,
    // darkmode,
    thankyou
}) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const userInformation = JSON.parse(localStorage.getItem('user'));

    const [currentPage, setCurrentPage] = useState(1);
    const [pageChange, setPageChange] = useState(0);
    const [activeSegment, setActiveSegment] = useState('');
    const [init, setInit] = useState(true);
    const cancelTokenSource = useRef();

    useEffect(() => {
        let isMounted = true;

        if (!isInitialized) {
            getPosts('new');
        }

        const hash = window.location.hash ? window.location.hash.replace('#', '') : '';
        const hashedEl = document.getElementById(hash);
        if (hashedEl && posts && posts.length > 0 && hash.length > 0) {
            hashedEl.scrollIntoView();
        }

        return () => {
            isMounted = false;

            dispatch(setPostIsInitialized(false));

            if (cancelTokenSource.current) {
                cancelTokenSource.current.cancel('Cancel shop request');
                cancelTokenSource.current = null;
            }

            resetPostLists();

            dispatch(setPostWasReset(true));
        };
    }, []);

    useLayoutEffect(() => {
        let mounted = true;

        const url = window.location.pathname;
        const urlParts = url.split('/').filter(path => path);
        const segment = urlParts.length > 0 ? urlParts[0].split('?') : '';

        if (segment && segment[0] !== 'home') {
            setActiveSegment(segment[0]);
        }

        return () => {
            mounted = false;
        };
    }, []);

    const observer = useRef();
    const lastPostElementRef = useCallback(node => {
        if (isLoading) return;
        if (observer.current) {
            observer.current.disconnect();
        }

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                setCurrentPage(currentPage => currentPage + 1);
                setPageChange(pageChange => pageChange + 1);
            }
        });

        if (node) observer.current.observe(node);
        return () => {
            observer.current.disconnect();
        };
    }, [isLoading, hasMore]);

    const getPosts = async (type = 'new') => {
        const pathname = window.location.pathname.replace('/', '');
        const parsed = queryString.parse(window.location.search);

        const url = window.location.href;
        const urlParts = url.split('/');
        const parameters = urlParts[urlParts.length - 1].split('?');
        const action = parsed.action;

        if ((parsed.postid && posts.length >= 1 && action !== 'go_to_post')) {
            return false;
        }

        if (parsed.postid) {
            history.replace({
                search: `postid=${parsed.postid}`
            });
        }

        if (type === 'new') {
            setCurrentPage(1);
        }

        if (cancelTokenSource.current) {
            cancelTokenSource.current.cancel('Abort post request');
        }

        const cancelToken = axios.CancelToken;
        const source = cancelToken.source();
        cancelTokenSource.current = source;

        const paramPage = type === 'new' ? 1 : currentPage;

        const params = {
            user: pathname ?? userInformation.login,
            currentPage: paramPage,
            perPage: perPage,
            postLn: paramPage === 1 ? 0 : posts.length,
            isPu: isPu,
            status: status,
            postid: parsed.postid,
            category_id: activeCategory && Object.keys(activeCategory).length > 0 ? activeCategory.id : '',
            pageName: parameters.length > 0 && parameters[0] ? parameters[0] : 'home', // pinned posts are excluded in homepage
            source,
            keyword
        };

        if (type === 'new') {
            setInit(false);
            dispatch(fetchPosts(params));
        } else {
            dispatch(appendPosts(params));
        }

        setRefetch(false);
    };

    useDidMountEffect(() => {
        let mounted = true;
        if (refetch) {
            setCurrentPage(1);
            setPageChange(pageChange => pageChange + 1);
        }

        return () => {
            mounted = false;
            setRefetch(false);
            setInit(false);
        };
    }, [refetch]);

    useDidMountEffect(() => {
        let mounted = true;

        if (cancelTokenSource.current) {
            cancelTokenSource.current = null;
        }

        return () => {
            mounted = false;
        };
    }, [posts]);

    useDidMountEffect(() => {
        let mounted = true;
        if (currentPage > 1) {
            getPosts('loadMore');
        } else {
            getPosts('new');
        }

        return () => {
            mounted = false;
        };
    }, [pageChange]);

    useDidMountEffect(() => {
        let mounted = true;
        setCurrentPage(1);
        setPageChange(pageChange => pageChange + 1);
        return () => {
            mounted = false;
        };
    }, [status]);

    const handleLike = (index) => {
        const currentLike = !posts[index].is_liked_by_user;
        posts[index].is_liked_by_user = currentLike;

        if (currentLike === false) {
            const userIndex = posts[index].likes.findIndex(like => like.user_id == userInformation.id);
            posts[index].likes.splice(userIndex, 1);
        } else {
            posts[index].likes.push({ user_id: userInformation.id });
        }

        setPosts(
            [...posts],
            posts[index]
        );
    };

    const resetPostLists = () => {
        dispatch(resetPosts());
    };

    const [activeCategory, setActiveCategory] = useState({});

    useDidMountEffect(() => {
        let mounted = true;
        getPosts('new');
        return () => {
            mounted = false;
        };
    }, [activeCategory]);

    useDidMountEffect(() => {
        let mounted = true;

        // add timeout because axios blocks same request after cancellation
        if (isReset) {
            setTimeout(() => {
                getPosts('new');
            }, 800);
        }

        return () => {
            mounted = false;
        };
    }, [isReset]);

    useDidMountEffect(() => {
        getPosts('new');
    }, [keyword]);

    useEffect(() => {
        $('#pu-content-container').height('fit-content');
    }, [posts]);

    // otherUserData
    const handleThankyou = (payload) => {
        dispatch(setPostThankyou({ ...thankyou, show: payload }));
    };

    return (
        // <div className="mb-5 posts-list-container">
        <div className="posts-list-container">
            {['', 'home'].indexOf(activeSegment) < 0 && <PostCategoryList
                activeCategory={activeCategory}
                setActiveCategory={setActiveCategory}
            />}
            <div className="posts-list-wrapper" id="posts-list">
                {
                    posts.map((post, index) => {
                        if (posts.length === index + 1) {
                            return <PostItem
                                ref={lastPostElementRef}
                                posts={posts}
                                post={post}
                                pu={user}
                                key={post.id}
                                likeHandler={handleLike}
                                index={index}
                                refetch={refetch}
                                setRefetch={setRefetch}
                                autoplay={false}
                            />;
                        } else {
                            return <PostItem
                                posts={posts}
                                post={post}
                                pu={user}
                                key={post.id}
                                likeHandler={handleLike}
                                index={index}
                                refetch={refetch}
                                setRefetch={setRefetch}
                                autoplay={false}
                            />;
                        }
                    })
                }

                <div className="text-center my-4" style={{ width: '100%' }}>
                    {
                        isLoading || !isInitialized
                            ? <PostSkeleton />
                            : (
                                posts.length == 0 && !isLoading
                                    ? <span className="sr-only profile-no-data">No posts available</span>
                                    : null
                            )
                    }
                </div>
            </div>

            {
                thankyou.show
                    ? <PThankYou
                        show={thankyou.show}
                        pu={thankyou.pu}
                        setShow={handleThankyou}
                        isUpgrade={thankyou.upgrade}
                    />
                    : null
            }
        </div>
    );
};

function mapStateToProps(state) {
    return {
        posts: state.post.posts,
        hasMore: state.post.hasMore,
        isLoading: state.post.isLoading,
        isInitialized: state.post.isInitialized,
        activePost: state.post.selectedPost,
        isReset: state.post.is_reset,
        keyword: state.post.keyword,
        darkmode: state.privaGlobal.darkmode,
        thankyou: state.post.thankyou
    };
}

// export default React.memo(PostsContent);
export default connect(mapStateToProps)(PostsContent);
